import {firstValueFrom} from 'rxjs';
import {GetUserUseCase} from './get-user.usecase';
import {DeliveryPointLocal} from '@app/core/delivery-point/domain/delivery-point.local';
import {UserIdentification, UserTrackingService} from './../domain/user-tacking.service';
import {Injectable} from '@angular/core';
import {RealUserMonitoringService} from '@app/presentation/services/real-user-monitoring.service';

export type NotifyUserHasChangedDTO  = Partial<UserIdentification>;

@Injectable({
    providedIn: 'root'
})
export class NotifyUserHasChangedUseCase {
    constructor(
        private userTrackingService: UserTrackingService,
        private deliveryPointLocal: DeliveryPointLocal,
        private getUserUseCase : GetUserUseCase,
        private realUserMonitoringService: RealUserMonitoringService,
    ) {}

    /**
     * Notify user has changed with the identification passed as parameter.
     * @param {NotifyUserHasChangedDTO} [identification] - NotifyUserHasChangedDTO
     */
    async execute(identification?: NotifyUserHasChangedDTO) {
        const currentDeliveryPointCode = await firstValueFrom(this.deliveryPointLocal.currentDeliveryPointCode$);
        const currentDeliveryPoint = await firstValueFrom(this.deliveryPointLocal.currentDeliveryPoint$);
        const currentUser = this.getUserUseCase.execute();
        
            const id = currentDeliveryPoint?.code
            const name = currentDeliveryPoint?.name
            const email = currentUser?.email
            const address = currentDeliveryPoint?.address
            const postalCode = currentDeliveryPoint?.postalCode
            const city = currentDeliveryPoint?.city
            const warehouse = currentDeliveryPoint?.warehouse
            const default_client = currentUser?.email
        
        
   
        if (currentDeliveryPointCode != null && currentUser) {

            this.realUserMonitoringService.setUser({
                id: id,
                name: name,
                email: email,
                address: address,
                postalCode: postalCode,
                city: city,
                warehouse: warehouse,
                default_client: default_client
            })

            this.userTrackingService.notifyUserHasChanged({
                email: identification?.email ?? currentUser.email,
                deliveryPointCode: identification?.deliveryPointCode ?? currentDeliveryPointCode
            });
            return;
        }
        this.userTrackingService.notifyUserHasChanged();
        this.realUserMonitoringService.clearUser();
        
    }
}
